import Promise from 'promise-polyfill';
import { ERROR_MESSAGES } from 'app/components/Profile/ProfileImage/ImageDropzone/constants';

export const uploadImageFromDropzone = (
  files: Array<File>,
  minDimension?: number
) =>
  new Promise<any>((resolve, reject) => {
    if (!files.length) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(files[0]);
    reader.onload = () => {
      const avatarDataUrl = reader.result;
      if (!avatarDataUrl) {
        reject(new Error('Image file conversion failed'));
      }

      const file = files[0];
      const image = new Image();

      image.onload = () => {
        const min = Math.min(image.width, image.height);
        if (minDimension && min < minDimension) {
          reject(new Error(ERROR_MESSAGES.DIMENSION_TOO_SMALL));
        }

        resolve({
          base64: reader.result,
          fileName: file.name,
          file,
        });
      };
      image.src = URL.createObjectURL(file);
    };
  });
